import { useLandingLanguage } from './LandingLanguage';
import React, { useEffect, useState } from 'react';

let playedThisVisit = false;
const prefersLessMotion = () => Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches);

const LandingIntro = () => {
  const { t } = useLandingLanguage();
  const [visible, setVisible] = useState(() => typeof window !== 'undefined' && !playedThisVisit && !prefersLessMotion());
  useEffect(() => {
    if (!visible) return;
    playedThisVisit = true;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const finish = () => setVisible(false);
    const timer = window.setTimeout(finish, 1500);
    const onKey = (event: KeyboardEvent) => { if (event.key === 'Escape' || event.key === 'Tab') finish(); };
    const media = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const onPreference = (event: MediaQueryListEvent) => { if (event.matches) finish(); };
    window.addEventListener('keydown', onKey);
    media?.addEventListener?.('change', onPreference);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('keydown', onKey);
      media?.removeEventListener?.('change', onPreference);
      document.body.style.overflow = overflow;
    };
  }, [visible]);
  if (!visible) return null;
  return <div className="orarivo-splash" role="region" aria-label={t("Introducere Orarivo")}>
    <div className="orarivo-splash-brand">
      <svg className="orarivo-splash-clock" viewBox="0 0 128 128" aria-hidden="true">
        <circle className="orarivo-splash-dial" cx="64" cy="64" r="48" fill="none" stroke="#185eac" strokeWidth="1"/>
        {Array.from({ length: 12 }, (_, index) => <line className="orarivo-splash-tick" key={index} x1="64" y1="9" x2="64" y2="15" transform={`rotate(${index * 30} 64 64)`} style={{ '--tick': index } as React.CSSProperties} stroke="#a4cfff" strokeWidth="2" strokeLinecap="round"/>)}
        <rect x="32" y="32" width="64" height="64" rx="14" fill="#185eac"/>
        <circle cx="64" cy="64" r="17" fill="none" stroke="#fff" strokeWidth="10"/>
        <g className="orarivo-splash-hand"><path d="M74 51v12h12" fill="none" stroke="#e1f5ee" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/></g>
      </svg>
      <span className="orarivo-splash-wordmark">orarivo</span>
      <span className="orarivo-splash-caption">{t("Fiecare lucru, la timpul lui.")}</span>
    </div>
  </div>;
};
export default LandingIntro;
